/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import classNames from 'classnames';
import moment from 'moment';
import React from 'react';
import env from 'utils/env';
import Avatar from '../Avatar/Avatar';
import styles from './Message.module.scss';
const URL_REGEX = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
function renderTextWithLinks(text) {
    let pos = 0;
    return text.split(URL_REGEX).map((part) => {
        const k = pos;
        pos += part.length;
        const isUrl = /^https?:\/\//.test(part) || /^www\./.test(part);
        const href = /^www\./.test(part) ? `https://${part}` : part;
        return isUrl ? (React.createElement("a", { key: k, href: href, target: "_blank", rel: "noopener noreferrer" }, part)) : (React.createElement(React.Fragment, { key: k }, part));
    });
}
function Message({ id, author, date, text, picture, sendByMe, size = 's', showName, showDate, }) {
    const classes = classNames(styles.wrap, styles[size], { [styles.sendByMe]: sendByMe });
    return (React.createElement("article", { className: classes, "data-testid": id },
        React.createElement("div", { className: styles.content, title: moment(date).format('HH:MM, DD.MM.YYYY') },
            showName && (React.createElement("p", { className: styles.author },
                size === 'm' && React.createElement(Avatar, { size: "xs", shape: "round", userName: author }),
                author)),
            picture && (React.createElement("blockquote", null,
                React.createElement("img", { src: `${env.static}/${picture}`, alt: "" }))),
            text && React.createElement("blockquote", null, renderTextWithLinks(text)),
            showDate && React.createElement("p", { className: styles.date }, moment(date).fromNow()))));
}
export default Message;
